<template>
  <v-card elevation="2" shaped class="ma-1">
    <v-toolbar flat color="primary" dark>
      <v-toolbar-title>Paramètres du module de génération XML UBL, CII </v-toolbar-title>
    </v-toolbar>

    <v-tabs align="start" background-color="blue lighten-5" v-model="tab">
          <v-tab> requetes pour les données</v-tab>
          <v-tab> attribution des données pour le document</v-tab>
          <v-tabs-items v-model="tab" class="pl-4">
            <v-tab-item>

                <v-btn fab small @click="addListe('query')"><v-icon>mdi-plus</v-icon></v-btn>
                <v-expansion-panels variant="popout" v-model="listQuerys" class="pa-3">
                <v-expansion-panel v-for="(query, i) in displays.params.querys" :key="'lf'+i">
                    <v-expansion-panel-header>
                    requete : {{query.description}}
                    <template v-slot:actions>
                        <v-btn icon @click="removeListe(i)" v-if="query.key!='default'"><v-icon>mdi-close-thick</v-icon></v-btn>
                    </template> 
                    </v-expansion-panel-header>

                    <v-expansion-panel-content class="grey lighten-3">

                    <div>
                        <TextField                  
                        :item="{name:'description',value:'description',defaultprops:{show:true}}" 
                        :keyup="(item,value) => {query.description = value } "
                        :valField="query.description"/>
                        <TextField                  
                        :item="{name:'Clé',value:'cle',defaultprops:{show:true}}" 
                        :keyup="(item,value) => {query.key = value } "
                        :valField="query.key"/>
                        <Select
                        :item="{name: 'table ciblée',value: 'table',liste: itemTableListe,
                        defaultprops:{ show: true,clearable:true } } "
                        :change="(item,value) => { query.table = value?.value || ''; } "
                        :valField="query.table"
                        />             
                    </div>

                    <v-tabs v-model="tabsFiche" v-if="query.table && query.table!=''">
                        <v-tab> Filtre </v-tab>
                        <v-tab> Champs </v-tab>
                        <v-tabs-items v-model="tabsFiche">
                        <v-tab-item>
                            <Filtre :page="page" :filtre="query.filtre" :table="query.table" />
                        </v-tab-item>
                        <v-tab-item> 
                            <Fields :page="page" :champs="query.champs" :modalKey="modalKey" :filter="query.filtre" :table="query.table" />
                        </v-tab-item>

                        </v-tabs-items>
                    </v-tabs>

                    </v-expansion-panel-content>  

                </v-expansion-panel>
                </v-expansion-panels>

            </v-tab-item>

          <v-tab-item>
    <v-tabs align="start" background-color="blue lighten-5" v-model="tab2">
          
          <v-tab>Infos générales</v-tab>
          <v-tab>Vendeur</v-tab>
          <v-tab>Acheteur</v-tab>
          <v-tab>Produits</v-tab>
          <v-tab>correspondances</v-tab>
          <v-tab>Aides</v-tab>
          <v-tabs-items v-model="tab2">
            <v-tab-item>

              <v-row>
                <v-col>
                  <h3>Facture</h3>
                    <Select
                    :item="{name: 'Type de document',value: 'type',liste: [{ text: 'UBL', value: 'UBL' },{ text: 'CII', value: 'CII' }],
                    defaultprops:{ show: true, column: false }}"
                    :change="(item,value) => { displays.params.documenttype = value.value }"
                    :valField="displays.params.documenttype"
                    />
                            <TextField                  
                            :item="{name:'code de facture (avoir ou facture etc..)',value:'',defaultprops:{show:true}}" 
                            :keyup="(item,value) => {displays.params.mapping.general.facturetype = value } "
                            :valField="displays.params.mapping.general.facturetype"/>
                            <TextField                  
                            :item="{name:'Businessprocess',value:'',defaultprops:{show:true}}" 
                            :keyup="(item,value) => {displays.params.mapping.general.businessprocess = value } "
                            :valField="displays.params.mapping.general.businessprocess"/>
                            <TextField                  
                            :item="{name:'N° de facture',value:'',defaultprops:{show:true}}" 
                            :keyup="(item,value) => {displays.params.mapping.general.nfact = value } "
                            :valField="displays.params.mapping.general.nfact"/>
                            <TextField                  
                            :item="{name:'Date de facture',value:'',defaultprops:{show:true}}" 
                            :keyup="(item,value) => {displays.params.mapping.general.issuedate = value } "
                            :valField="displays.params.mapping.general.issuedate"/>
                            <TextField                  
                            :item="{name:'Unité monétaire',value:'',defaultprops:{show:true}}" 
                            :keyup="(item,value) => {displays.params.mapping.general.currency = value } "
                            :valField="displays.params.mapping.general.currency"/>
                            <TextField                  
                            :item="{name:'Montant déjà versé par le vendeur',value:'',defaultprops:{show:true}}" 
                            :keyup="(item,value) => {displays.params.mapping.general.paidamount = value } "
                            :valField="displays.params.mapping.general.paidamount"/>
                            <TextField                  
                            :item="{name:'Montant total TTC (pour arrondi)',value:'',defaultprops:{show:true}}" 
                            :keyup="(item,value) => {displays.params.mapping.general.totalttc = value } "
                            :valField="displays.params.mapping.general.totalttc"/>
                </v-col>
                <v-col>
                  <h3>Modes de paiement</h3><v-btn class="primary d-flex" x-small @click="addListe('means')">+</v-btn>
                    <Select
                    :item="{name: 'Insertion',value: 'type',liste: [{ text: 'manuelle', value: 'manual' },{ text: 'automatique', value: 'auto' }],
                    defaultprops:{ show: true, column: false }}"
                    :change="(item,value) => { displays.params.mapping.paiement.means.type = value.value }"
                    :valField="displays.params.mapping.paiement.means.type"
                    />
                    <div v-if="displays.params.mapping.paiement.means.type=='auto'">
                            <TextField                  
                            :item="{name:'clé de requete pour la liste des paiements',value:'',defaultprops:{show:true}}" 
                            :keyup="(item,value) => {displays.params.mapping.paiement.means.querykey = value } "
                            :valField="displays.params.mapping.paiement.means.querykey"/>                      
                      Entrez le champ dynamique du code et de la description (il y aura autant de paiments que de résultat de requete)
                    </div>
                  <div v-for="(paiem,i) in displays.params.mapping.paiement.means.list" :key="i+'paim'" class="elevation-1">
                    <div v-if="displays.params.mapping.paiement.means.type=='manual' || (displays.params.mapping.paiement.means.type=='auto' && i>0)">
                      paiement N°{{ i+1 }} <v-btn class="secondary d-flex" x-small @click="removeListe('means',i)" >x</v-btn>
                    </div>                    
                            <TextField                  
                            :item="{name:'Code de paiement',value:'',defaultprops:{show:true}}" 
                            :keyup="(item,value) => {paiem.code = value } "
                            :valField="paiem.code"/>    
                            <TextField                  
                            :item="{name:'description de paiement',value:'',defaultprops:{show:true}}" 
                            :keyup="(item,value) => {paiem.description = value } "
                            :valField="paiem.description"/>       
                  </div>
                </v-col>
                <v-col>
                  <h3>Termes de paiement</h3><v-btn class="primary d-flex" x-small @click="addListe('terms')" >+</v-btn>
                    <Select
                    :item="{name: 'Insertion',value: 'type',liste: [{ text: 'manuelle', value: 'manual' },{ text: 'automatique', value: 'auto' }],
                    defaultprops:{ show: true, column: false }}"
                    :change="(item,value) => { displays.params.mapping.paiement.terms.type = value.value }"
                    :valField="displays.params.mapping.paiement.terms.type"
                    />
                    <div v-if="displays.params.mapping.paiement.terms.type=='auto'">
                            <TextField                  
                            :item="{name:'clé de requete pour la liste des paiements',value:'',defaultprops:{show:true}}" 
                            :keyup="(item,value) => {displays.params.mapping.paiement.terms.querykey = value } "
                            :valField="displays.params.mapping.paiement.terms.querykey"/>                      
                      Entrez le champ dynamique de la date et de la descr. (il y aura autant de termes que de résultat de requete)
                    </div>
                    
                  <div v-for="(paiem,i) in displays.params.mapping.paiement.terms.list" :key="i+'term'" class="elevation-1">
                    <div v-if="displays.params.mapping.paiement.terms.type=='manual' || (displays.params.mapping.paiement.terms.type=='auto' && i>0)">
                      Terme N°{{ i+1 }}<v-btn class="secondary d-flex" x-small @click="removeListe('terms',i)" >x</v-btn>
                    </div>
                                <TextField                  
                                :item="{name:'Date de validité',value:'',defaultprops:{show:true}}" 
                                :keyup="(item,value) => {paiem.duedate = value } "
                                :valField="paiem.duedate"/>    
                                <TextField                  
                                :item="{name:'description du terme',value:'',defaultprops:{show:true}}" 
                                :keyup="(item,value) => {paiem.description = value } "
                                :valField="paiem.description"/>       
                  </div>
                </v-col>
                <v-col>
                  <h3>Notes</h3><v-btn class="primary d-flex" x-small @click="addListe('note')" >+</v-btn>
                    
                  <div v-for="(note,i) in displays.params.mapping.general.notes" :key="i+'note'" class="elevation-1">
                    <div>
                      note N°{{ i+1 }}<v-btn class="secondary d-flex" x-small @click="removeListe('note',i)" >x</v-btn>
                    </div>
                                <TextField                  
                                :item="{name:'code',value:'',defaultprops:{show:true}}" 
                                :keyup="(item,value) => {note.code = value } "
                                :valField="note.code"/>    
                                <TextField                  
                                :item="{name:'description',value:'',defaultprops:{show:true}}" 
                                :keyup="(item,value) => {note.content = value } "
                                :valField="note.content"/>       
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <h3>Compte bancaire</h3>
                                <TextField                  
                                :item="{name:'N° du compte',value:'',defaultprops:{show:true}}" 
                                :keyup="(item,value) => {displays.params.mapping.general.bankaccountid = value } "
                                :valField="displays.params.mapping.general.bankaccountid"/>
                                <TextField                  
                                :item="{name:'Nom du compte',value:'',defaultprops:{show:true}}" 
                                :keyup="(item,value) => {displays.params.mapping.general.bankaccountname = value } "
                                :valField="displays.params.mapping.general.bankaccountname"/>        
                                <TextField                  
                                :item="{name:'N° BIC',value:'',defaultprops:{show:true}}" 
                                :keyup="(item,value) => {displays.params.mapping.general.bankaccountbic = value } "
                                :valField="displays.params.mapping.general.bankaccountbic"/>                                            
                </v-col>
                <v-col>
                  <h3>Remise ou charge générale</h3>
                                <TextField                  
                                :item="{name:'Type (remise, charge)',value:'',defaultprops:{show:true}}" 
                                :keyup="(item,value) => {displays.params.mapping.general.allowance.type = value } "
                                :valField="displays.params.mapping.general.allowance.type"/>
                                <TextField                  
                                :item="{name:'Raison Code',value:'',defaultprops:{show:true}}" 
                                :keyup="(item,value) => {displays.params.mapping.general.allowance.code = value } "
                                :valField="displays.params.mapping.general.allowance.code"/>        
                                <TextField                  
                                :item="{name:'En pourcentage (NON, YES)',value:'',defaultprops:{show:true}}" 
                                :keyup="(item,value) => {displays.params.mapping.general.allowance.percentage = value } "
                                :valField="displays.params.mapping.general.allowance.percentage"/>        
                                <TextField                  
                                :item="{name:'Montant',value:'',defaultprops:{show:true}}" 
                                :keyup="(item,value) => {displays.params.mapping.general.allowance.amount = value } "
                                :valField="displays.params.mapping.general.allowance.amount"/>             
                  <h3>Taxe sur remise (obligatoire si remise)</h3>                 
                          <TextField                  
                          :item="{name:'Type',value:'',defaultprops:{show:true}}" 
                          :keyup="(item,value) => {displays.params.mapping.general.allowance.tax.type = value }"
                          :valField="displays.params.mapping.general.allowance.tax.type"/>    
                          <TextField                  
                          :item="{name:'pourcentage',value:'',defaultprops:{show:true}}" 
                          :keyup="(item,value) => {displays.params.mapping.general.allowance.tax.rate = value }"
                          :valField="displays.params.mapping.general.allowance.tax.rate"/> 
                          <TextField                  
                          :item="{name:'Catégorie',value:'',defaultprops:{show:true}}" 
                          :keyup="(item,value) => {displays.params.mapping.general.allowance.tax.categ = value }"
                          :valField="displays.params.mapping.general.allowance.tax.categ"/> 
                          <TextField                  
                          :item="{name:'Mention applicable',value:'',defaultprops:{show:true}}" 
                          :keyup="(item,value) => {displays.params.mapping.general.allowance.tax.mention = value }"
                          :valField="displays.params.mapping.general.allowance.tax.mention"/>        
                </v-col>
              </v-row>

            </v-tab-item>

            <v-tab-item>

                  <TextField                  
                  :item="{name:'nom de la compagnie',value:'',defaultprops:{show:true}}" 
                  :keyup="(item,value) => {displays.params.mapping.seller.name = value } "
                  :valField="displays.params.mapping.seller.name"/>   
                  <TextField                  
                  :item="{name:'id scheme de la companie',value:'',defaultprops:{show:true}}" 
                  :keyup="(item,value) => {displays.params.mapping.seller.companieidscheme = value } "
                  :valField="displays.params.mapping.seller.companieidscheme"/> 
                  <TextField                  
                  :item="{name:'N° de TVA',value:'',defaultprops:{show:true}}" 
                  :keyup="(item,value) => {displays.params.mapping.seller.vatnumber = value } "
                  :valField="displays.params.mapping.seller.vatnumber"/>  
                  <TextField                  
                  :item="{name:'ID de compagnie',value:'',defaultprops:{show:true}}" 
                  :keyup="(item,value) => {displays.params.mapping.seller.companieid = value } "
                  :valField="displays.params.mapping.seller.companieid"/>    
                  <TextField                  
                  :item="{name:'Rue',value:'',defaultprops:{show:true}}" 
                  :keyup="(item,value) => {displays.params.mapping.seller.adress.street = value } "
                  :valField="displays.params.mapping.seller.adress.street"/> 
                  <TextField                  
                  :item="{name:'Code postal',value:'',defaultprops:{show:true}}" 
                  :keyup="(item,value) => {displays.params.mapping.seller.adress.postcode = value } "
                  :valField="displays.params.mapping.seller.adress.postcode"/>    
                  <TextField                  
                  :item="{name:'ville',value:'',defaultprops:{show:true}}" 
                  :keyup="(item,value) => {displays.params.mapping.seller.adress.city = value } "
                  :valField="displays.params.mapping.seller.adress.city"/>    
                  <TextField                  
                  :item="{name:'Pays',value:'',defaultprops:{show:true}}" 
                  :keyup="(item,value) => {displays.params.mapping.seller.adress.country = value } "
                  :valField="displays.params.mapping.seller.adress.country"/>  
                  <TextField                  
                  :item="{name:'adresse e-mail',value:'',defaultprops:{show:true}}" 
                  :keyup="(item,value) => {displays.params.mapping.seller.email = value } "
                  :valField="displays.params.mapping.seller.email"/>        
                  <TextField                  
                  :item="{name:'adresse electronique (identifiant)',value:'',defaultprops:{show:true}}" 
                  :keyup="(item,value) => {displays.params.mapping.seller.electronicadress = value } "
                  :valField="displays.params.mapping.seller.electronicadress"/>      
            </v-tab-item>

            <v-tab-item>
              <v-row>
                <v-col>
                  <h3>Informations sur l'acheteur</h3>
                    <TextField                  
                    :item="{name:'nom de la compagnie',value:'',defaultprops:{show:true}}" 
                    :keyup="(item,value) => {displays.params.mapping.buyer.name = value } "
                    :valField="displays.params.mapping.buyer.name"/>    
                    <TextField                  
                    :item="{name:'N° de TVA',value:'',defaultprops:{show:true}}" 
                    :keyup="(item,value) => {displays.params.mapping.buyer.vatnumber = value } "
                    :valField="displays.params.mapping.buyer.vatnumber"/>  
                    <TextField                  
                    :item="{name:'ID de compagnie',value:'',defaultprops:{show:true}}" 
                    :keyup="(item,value) => {displays.params.mapping.buyer.companieid = value } "
                    :valField="displays.params.mapping.buyer.companieid"/>    
                    <TextField                  
                    :item="{name:'Rue',value:'',defaultprops:{show:true}}" 
                    :keyup="(item,value) => {displays.params.mapping.buyer.adress.street = value } "
                    :valField="displays.params.mapping.buyer.adress.street"/> 
                    <TextField                  
                    :item="{name:'Code postal',value:'',defaultprops:{show:true}}" 
                    :keyup="(item,value) => {displays.params.mapping.buyer.adress.postcode = value } "
                    :valField="displays.params.mapping.buyer.adress.postcode"/>    
                    <TextField                  
                    :item="{name:'ville',value:'',defaultprops:{show:true}}" 
                    :keyup="(item,value) => {displays.params.mapping.buyer.adress.city = value } "
                    :valField="displays.params.mapping.buyer.adress.city"/>    
                    <TextField                  
                    :item="{name:'Pays',value:'',defaultprops:{show:true}}" 
                    :keyup="(item,value) => {displays.params.mapping.buyer.adress.country = value } "
                    :valField="displays.params.mapping.buyer.adress.country"/>
                  <TextField                  
                  :item="{name:'adresse e-mail',value:'',defaultprops:{show:true}}" 
                  :keyup="(item,value) => {displays.params.mapping.buyer.email = value } "
                  :valField="displays.params.mapping.buyer.email"/> 
                  <TextField                  
                  :item="{name:'adresse electronique (identifiant)',value:'',defaultprops:{show:true}}" 
                  :keyup="(item,value) => {displays.params.mapping.buyer.electronicadress = value } "
                  :valField="displays.params.mapping.buyer.electronicadress"/>   
                </v-col>
                <v-col class="col-md-6 col-12">
                  <h3>Lieu de livraison (si différent de l'acheteur) Vous pouvez mettre les informations meme si cela est similaire</h3>
                    <TextField                  
                    :item="{name:'Rue',value:'',defaultprops:{show:true}}" 
                    :keyup="(item,value) => {displays.params.mapping.delivery.street = value } "
                    :valField="displays.params.mapping.delivery.street"/> 
                    <TextField                  
                    :item="{name:'Code postal',value:'',defaultprops:{show:true}}" 
                    :keyup="(item,value) => {displays.params.mapping.delivery.postcode = value } "
                    :valField="displays.params.mapping.delivery.postcode"/>    
                    <TextField                  
                    :item="{name:'ville',value:'',defaultprops:{show:true}}" 
                    :keyup="(item,value) => {displays.params.mapping.delivery.city = value } "
                    :valField="displays.params.mapping.delivery.city"/>    
                    <TextField                  
                    :item="{name:'Pays',value:'',defaultprops:{show:true}}" 
                    :keyup="(item,value) => {displays.params.mapping.delivery.country = value } "
                    :valField="displays.params.mapping.delivery.country"/> 
                </v-col>
              </v-row>


            </v-tab-item>

            <v-tab-item>

                  <h3>Liste des Produits</h3><v-btn class="primary d-flex" x-small @click="addListe('produits')" >+</v-btn>
                    <Select
                    :item="{name: 'Insertion',value: 'type',liste: [{ text: 'manuelle', value: 'manual' },{ text: 'automatique', value: 'auto' }],
                    defaultprops:{ show: true, column: false }}"
                    :change="(item,value) => { displays.params.mapping.products.type = value.value }"
                    :valField="displays.params.mapping.products.type"
                    />
                    <div v-if="displays.params.mapping.products.type=='auto'">
                            <TextField                  
                            :item="{name:'clé de requete pour la liste des produits',value:'',defaultprops:{show:true}}" 
                            :keyup="(item,value) => {displays.params.mapping.products.querykey = value } "
                            :valField="displays.params.mapping.products.querykey"/>                      
                      Entrez les champs dynamiques issue de la requete
                    </div>
                    
                  <div v-for="(prod,i) in displays.params.mapping.products.list" :key="i+'prod'" class="elevation-1">
                    <div v-if="displays.params.mapping.products.type=='manual' || (displays.params.mapping.products.type=='auto' && i>0)">
                      Produit N°{{ i+1 }}<v-btn class="secondary d-flex" x-small @click="removeListe('produits',i)" >x</v-btn>
                    </div>
                    <v-row align="start">
                      <v-col>
                          <TextField                  
                          :item="{name:'Nom du produit',value:'',defaultprops:{show:true}}" 
                          :keyup="(item,value) => {prod.name = value } "
                          :valField="prod.name"/>    
                          <TextField                  
                          :item="{name:'Quantité',value:'',defaultprops:{show:true}}" 
                          :keyup="(item,value) => {prod.quantity = value } "
                          :valField="prod.quantity"/> 
                          <TextField                  
                          :item="{name:'Code d\'unité',value:'',defaultprops:{show:true}}" 
                          :keyup="(item,value) => {prod.unitcode = value } "
                          :valField="prod.unitcode"/> 
                          <TextField                  
                          :item="{name:'Prix unitaire',value:'',defaultprops:{show:true}}" 
                          :keyup="(item,value) => {prod.unitprice = value } "
                          :valField="prod.unitprice"/>  
                      </v-col>
                      <v-col>
                        Taxes appliquées
                        <v-btn class="primary d-flex" x-small @click="addListe('tax',i)" >+</v-btn>
                        <div v-for="(tax,t) in prod.tax" :key="t+'t'">
                          taxe N°{{ t+1 }}<v-btn class="secondary d-flex" x-small @click="removeListe('tax',t,i)" >x</v-btn>
                          <TextField                  
                          :item="{name:'Type',value:'',defaultprops:{show:true}}" 
                          :keyup="(item,value) => {tax.type = value }"
                          :valField="tax.type"/>    
                          <TextField                  
                          :item="{name:'pourcentage',value:'',defaultprops:{show:true}}" 
                          :keyup="(item,value) => {tax.rate = value }"
                          :valField="tax.rate"/> 
                          <TextField                  
                          :item="{name:'Catégorie',value:'',defaultprops:{show:true}}" 
                          :keyup="(item,value) => {tax.categ = value }"
                          :valField="tax.categ"/> 
                          <TextField                  
                          :item="{name:'Mention applicable',value:'',defaultprops:{show:true}}" 
                          :keyup="(item,value) => {tax.mention = value }"
                          :valField="tax.mention"/>                          
                        </div>
                      </v-col>
                      <v-col>
                        remise potentielle
                            <TextField                  
                            :item="{name:'Type (remise, charge)',value:'',defaultprops:{show:true}}" 
                            :keyup="(item,value) => {prod.allowance.type = value } "
                            :valField="prod.allowance.type"/>
                            <TextField                  
                            :item="{name:'Raison Code',value:'',defaultprops:{show:true}}" 
                            :keyup="(item,value) => {prod.allowance.code = value } "
                            :valField="prod.allowance.code"/>   
                            <TextField                  
                            :item="{name:'Raison texte',value:'',defaultprops:{show:true}}" 
                            :keyup="(item,value) => {prod.allowance.reason = value } "
                            :valField="prod.allowance.reason"/>     
                            <TextField                  
                            :item="{name:'En pourcentage (NON, YES)',value:'',defaultprops:{show:true}}" 
                            :keyup="(item,value) => {prod.allowance.percentage = value } "
                            :valField="prod.allowance.percentage"/>        
                            <TextField                  
                            :item="{name:'Montant',value:'',defaultprops:{show:true}}" 
                            :keyup="(item,value) => {prod.allowance.amount = value } "
                            :valField="prod.allowance.amount"/> 
                      </v-col>
                    </v-row>
     
                  </div>
            </v-tab-item>

            <v-tab-item>
              <h4>Si votre système n'intègre pas les codes pour la norme EN16931, vous pouvez faire correspondre les résultats de votre base, aux codes correspondants ici :</h4>
              
              <v-row>
              <v-col v-for="(help,type) in displays.params.helpmapdatas" :key="type">
                {{ type }}
                <v-btn class="primary d-flex" x-small @click="addListe('help',type)" >+</v-btn>
                  <div v-for="(elem,h) in help" :key="h+'h'" class="elevation-1">
                    <v-btn class="secondary d-flex" x-small @click="removeListe('help',h,type)" >x</v-btn>
                    <Select
                    :item="{name: 'code',value: 'type',liste: buildingParameters.facturexml[type],
                    defaultprops:{ show: true, column: false }}"
                    :change="(item,value) => { elem.code = value.value }"
                    :valField="elem.code"
                    />  
                                <TextField                  
                                :item="{name:'Valeur dans la base',value:'',defaultprops:{show:true}}" 
                                :keyup="(item,value) => {elem.bdd = value } "
                                :valField="elem.bdd"/>       
                  </div>
              </v-col>
            </v-row>
            
            </v-tab-item>

            <v-tab-item>
              <h3>Liste des éléments pour insertion dans les différentes cases</h3>
              
              <v-row>
                <v-col>
                  <h4>Codes de paiement</h4>
                  <div v-for="(c,i) in this.buildingParameters.facturexml.paiementcode" :key="i+'hpaiem'">{{c.value}} : {{ c.text }}</div>
                </v-col>
                <v-col>
                  <h4>Codes d'Unités pour les produits</h4>
                  <div v-for="(c,i) in this.buildingParameters.facturexml.unitcode" :key="i+'hunit'">{{c.value}} : {{ c.text }}</div>
                </v-col>
                <v-col>
                  <h4>Catégories de TVA</h4>
                  <div v-for="(c,i) in this.buildingParameters.facturexml.categorietaxe" :key="i+'hvat'">{{c.value}} : {{ c.text }}</div>
                </v-col>
                <v-col>
                  <h4>type de TVA (OTHER obligatoire si différent de "S")</h4>
                  <div v-for="(c,i) in this.buildingParameters.facturexml.typetaxe" :key="i+'htvat'">{{c.value}} : {{ c.text }}</div>
                </v-col>
                <v-col>
                  <h4>Codes de remises commerciales</h4>
                  <div v-for="(c,i) in this.buildingParameters.facturexml.allowancereasoncode" :key="i+'htvat'">{{c.value}} : {{ c.text }}</div>
                </v-col>
                <v-col>
                  <h4>Type de facture</h4>
                  <div v-for="(c,i) in this.buildingParameters.facturexml.facturetype" :key="i+'htvat'">{{c.value}} : {{ c.text }}</div>
                </v-col>
              </v-row>
              
            </v-tab-item>

          </v-tabs-items>
    </v-tabs>
          </v-tab-item>
          
          </v-tabs-items>
            </v-tabs>



  </v-card>
</template>



<script>
    import { admin } from '../mixins'; 
export default {
  name: "FactureX",

   mixins : [admin],

  data: function () {
    return {
      tab : '',
      tab2 : '',
      tabsFiche : '',
      displays: this.module.displays,
      listQuerys : '',
    };
  },

  methods: {
            addListe(type,index) {
              let defaultL = {}
            switch(type) {
              case 'query' :
                defaultL = JSON.parse(JSON.stringify(this.buildingParameters.facturexml.defaultquery));
                this.displays.params.querys.push(defaultL);
                break;
              case 'means' :
                defaultL = JSON.parse(JSON.stringify(this.buildingParameters.facturexml.paiementmeans));
                this.displays.params.mapping.paiement.means.list.push(defaultL);                
                break;
              case 'terms' :
                defaultL = JSON.parse(JSON.stringify(this.buildingParameters.facturexml.paiementterms));
                this.displays.params.mapping.paiement.terms.list.push(defaultL);                 
                break;
              case 'note' :
                defaultL = JSON.parse(JSON.stringify(this.buildingParameters.facturexml.note));
                this.displays.params.mapping.general.notes.push(defaultL);                 
                break;
              case 'produits' :
                defaultL = JSON.parse(JSON.stringify(this.buildingParameters.facturexml.product));
                this.displays.params.mapping.products.list.push(defaultL);                 
                break;
              case 'tax' :
                defaultL = JSON.parse(JSON.stringify(this.buildingParameters.facturexml.taxline));
                this.displays.params.mapping.products.list[index].tax.push(defaultL);                 
                break;
              case 'help' :
                defaultL = JSON.parse(JSON.stringify(this.buildingParameters.facturexml.correspondance));
                this.displays.params.helpmapdatas[index].push(defaultL);                 
                break;
            }

            },
            removeListe(type,i,help) {
            switch(type) {
              case 'query' :
                this.displays.params.querys = this.displays.params.querys.filter((_, index) => index !== i)
                break;
              case 'means' :
                this.displays.params.mapping.paiement.means.list = this.displays.params.mapping.paiement.means.list.filter((_, index) => index !== i)                 
                break;
              case 'terms' :
                this.displays.params.mapping.paiement.terms.list = this.displays.params.mapping.paiement.terms.list.filter((_, index) => index !== i)               
                break;
              case 'note' :
                this.displays.params.mapping.general.notes = this.displays.params.mapping.general.notes.filter((_, index) => index !== i)               
                break;
              case 'produits' :
                this.displays.params.mapping.products.list = this.displays.params.mapping.products.list.filter((_, index) => index !== i)               
                break;
              case 'tax' :
                this.displays.params.mapping.products.list[help].tax = this.displays.params.mapping.products.list[help].tax.filter((_, index) => index !== i)               
                break;
              case 'help' :
                this.displays.params.helpmapdatas[help] = this.displays.params.helpmapdatas[help].filter((_, index) => index !== i)               
                break;
            }

            },

  },

  mounted() {
    //this.getFromAPI();
  },
}
</script>

